<template>
  <ul :class="`${listClasses} toggling-dropdown`">
    <li class="dropdown-header">Identity</li>
    <ReportColumnToggle
      query-property="show_employee_id"
      :update-search="false"
    >
      Employee ID
    </ReportColumnToggle>
    <ReportColumnToggle
      query-property="show_birthday"
      :update-search="false"
    >
      Birthday
    </ReportColumnToggle>
    <ReportColumnToggle
      query-property="show_ip_address"
      :update-search="false"
    >
      IP address (date)
    </ReportColumnToggle>

    <li class="dropdown-header">Work contact</li>
    <ReportColumnToggle
      query-property="show_work_state_country"
      :update-search="false"
    >
      State, Country
    </ReportColumnToggle>
    <ReportColumnToggle
      query-property="show_work_email"
      :update-search="false"
    >
      Work email
    </ReportColumnToggle>
    <ReportColumnToggle
      query-property="show_work_phone"
      :update-search="false"
    >
      Work phone
    </ReportColumnToggle>

    <li class="dropdown-header">Personal contact</li>
    <ReportColumnToggle
      query-property="show_home_state_country"
      :update-search="false"
    >
      State, Country
    </ReportColumnToggle>
    <ReportColumnToggle
      query-property="show_personal_email"
      :update-search="false"
    >
      Personal email
    </ReportColumnToggle>
    <ReportColumnToggle
      query-property="show_personal_phone"
      :update-search="false"
    >
      Personal phone
    </ReportColumnToggle>

    <li
      v-if="customFieldsList.length"
      class="dropdown-header"
    >
      Custom
    </li>
    <ReportColumnToggle
      v-for="field in customFieldsList"
      :key="field.key"
      :query-property="`show_custom_${field.key}`"
      :update-search="false"
    >
      {{ field.title }}
    </ReportColumnToggle>
  </ul>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'ReportShowMemberInfoColumnToggleFields',
  props: {
    listClasses: {
      type: String,
      default: 'dropdown-menu dropdown-submenu-left reports-dropdown',
    },
  },
  computed: {
    ...mapState(['organization']),
    customFieldsList() {
      return this.organization.member_profile_fields;
    },
  },
};
</script>
